import { authenticatedFetch } from "@/services/utils/authenticatedFetch";

export interface BlockbrainBot {
  id: string;
  name: string;
  botTemplate?: string | null;
  iconUrl?: string | null;
  model?: string | null;
  tags?: string[];
  isArchived?: boolean;
}

export interface BlockbrainBotsResponse {
  ok: boolean;
  bots?: BlockbrainBot[];
  error?: string;
  status?: number;
}

/**
 * Fetch the list of Active Knowledge Bots visible to the configured API key.
 *
 * If `payload` is provided, the backend will use those credentials instead of
 * the ones currently saved (useful while the admin types new credentials).
 */
export async function listBlockbrainBots(payload?: {
  apiKey?: string;
  apiUrl?: string;
}): Promise<BlockbrainBotsResponse> {
  try {
    const usePost = !!payload && (payload.apiKey || payload.apiUrl);
    const response = await authenticatedFetch("/api/blockbrain-bots", {
      method: usePost ? "POST" : "GET",
      body: usePost ? JSON.stringify(payload) : undefined,
    });
    const json = (await response.json()) as BlockbrainBotsResponse;
    return json;
  } catch (error) {
    console.error("Error fetching Blockbrain bots:", error);
    return { ok: false, error: error instanceof Error ? error.message : String(error) };
  }
}
